import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from '../styles/modal.module.css'
import { toast } from 'react-toastify';
import StateContext from '../context/state/StateContext';
import UserContext from '../context/user/UserContext';
import axios from 'axios';
import { FaLink } from "react-icons/fa6";
import { AiOutlineFolderOpen } from "react-icons/ai";
import { IoMdAlarm } from "react-icons/io";
import { IoFlag } from "react-icons/io5";
import { IoCheckmarkSharp } from "react-icons/io5";
import { IoIosMic } from "react-icons/io";
import Links from './Links';
import useVoiceRecorder from './useVoiceRecorder';
import { FaRegCircleStop } from "react-icons/fa6";
import CustomReminder from './CustomReminder';
import { IoSearch } from "react-icons/io5";
import Fuse from 'fuse.js';


const AddRequest = (props) => {

    const { isRecording, audioBlob, startRecording, stopRecording } = useVoiceRecorder();
    const { ticket, setTicket, setTickets, token, employees, setEmployees, setLoading, groupDetails, reminderData, setReminderData, agencies, setAgencies, agencyDetails, setAgencyDetails, requests, setRequests, tags } = useContext(StateContext)
    const { user, getEmployees, fetchGroupDetails } = useContext(UserContext)
    const [select, setSelect] = useState('');
    const [drop, setDrop] = useState(Array(2).fill(false));
    const [disabled, setDisabled] = useState(true);
    const [assigned, setAssigned] = useState([]);
    const [clientName, setClientName] = useState({ id: '', name: '' });
    const [error, setError] = useState('');
    const [fields, setFields] = useState({ component: '', open: false });
    const [link, setLink] = useState('');
    const [links, setLinks] = useState([]);
    const [files, setFiles] = useState([]);
    const [priority, setPriority] = useState('Low');
    const [dateTime, setDateTime] = useState({ date: '', time: '' });
    const [repeat, setRepeat] = useState('does_not_repeat')
    const [repeatChecked, setRepeatChecked] = useState(false);
    const [group, setGroup] = useState('')
    const [agency, setAgency] = useState('')
    const [tag, setTag] = useState([])
    const [allEmployees, setAllEmployees] = useState(employees);
    const [searchQuery, setSearchQuery] = useState('');
    const [tagQuery, setTagQuery] = useState('');
    const [filteredAgencies, setFilteredAgencies] = useState();
    const [filteredTags, setFilteredTags] = useState([])
    const [selectedTags, setSelectedTags] = useState([])
    const [agencyQuery, setAgencyQuery] = useState('');
    const [filteredEmployees, setFilteredEmployees] = useState();
    const [formDetails, setFormDetails] = useState({title:"", description:"", tags:[], deadline:"", agencyId: "", priority:priority})


    const searchDropRef = useRef(null);
    const searchAgencyRef = useRef(null);
    const searchTagRef = useRef(null);

    const fuse = new Fuse(filteredEmployees && filteredEmployees, {
        keys: ['username'], // Search by the 'name' key
        threshold: 0.4, // Fuzzy match threshold (lower = stricter matches)
    });

    const handleSearch = (event) => {
        const query = event.target.value;
        setSearchQuery(query);

        if (query.trim() === '') {
            setFilteredEmployees(allEmployees);
        } else {
            const results = fuse.search(query);
            setFilteredEmployees(results.map(result => result.item));
        }
    };

    // group filter code hrere 

    const fuse1 = agencies && new Fuse(agencies, {
        keys: ['name'], // Search by the 'name' key
        threshold: 0.4, // Fuzzy match threshold (lower = stricter matches)
    });

    const fuse2 = filteredTags && new Fuse(filteredTags, {
        keys: ['name'], // Search by the 'name' key
        threshold: 0.4, // Fuzzy match threshold (lower = stricter matches)
    });



    const handleAgencySearch = (event) => {
        const query = event.target.value;
        setAgencyQuery(query);

        if (query.trim() === '') {
            setFilteredAgencies(agencies);
        } else {
            const results = fuse1.search(query);
            setFilteredAgencies(results.map(result => result.item));
        }
    };
    const handleTagSearch = (event) => {
        const query = event.target.value;
        setTagQuery(query);

        if (query.trim() === '') {
            setFilteredTags(tags);
        } else {
            const results = fuse2.search(query);
            setFilteredTags(results.map(result => result.item));
        }
    };

    useEffect(() => {
        setFilteredAgencies(agencies)
        setFilteredTags(tags)
        setFilteredEmployees(employees.filter(employee => employee.role === "hod"))
        setAllEmployees(employees.filter(employee => employee.role === "hod"))
    }, [])


    const handleDrop = (index) => {
        const array = [...drop]
        array[index] = !drop[index]
        setDrop(array)
    }

    const assignedDrop = (id, username, action) => {
        const current = { id: id, username: username }
        if(assigned.length === 2){
            setError("you cannot select more than 2 hods")
        }
        if (action === 'add') {
            // Add the item to the assigned list
            setAssigned(prev => [...prev, { id, username }]);
        } else if (action === 'remove') {
            // Remove the item from the assigned list
            setAssigned(prev => prev.filter(item => item.username !== username));
        }
        setDisabled(false)
        // setDrop(false)
        setError('')
    }

    const selectedDrop = (id, name, action) => {
        const current = { id: id, name: name }
        if (action === 'add') {
            // Add the item to the assigned list
            setSelectedTags(prev => [...prev, { id, name }]);
        } else if (action === 'remove') {
            // Remove the item from the assigned list
            setSelectedTags(prev => prev.filter(item => item.name !== name));
        }
        setDisabled(false)
        // setDrop(false)
        setError('')
    }

    const clientDrop = (id, name) => {
        setClientName({ id, name })
        setDisabled(false)
        setDrop(false)
        setError('')
    }

    const handleChange = (e) => {
        setDisabled(false)
        setError('')
        setFormDetails({ ...formDetails, [e.target.name]: e.target.value })
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading({ open: true, text: "Adding" })
            const formData = new FormData();
            formData.append('title', formDetails.title);
            formData.append('description', formDetails.description);
            formData.append('tags', JSON.stringify(selectedTags.map(item => {return item.id})));
            formData.append('links', JSON.stringify(links));
            formData.append('priority', priority);
            formData.append('deadline', dateTime.date);
            formData.append('agencyId', agency.id);
            formData.append('hods', JSON.stringify(assigned.map(item => {return item.id})))

            if (audioBlob !== null) {
                formData.append('audio', audioBlob, 'voice-recording.wav');
            }
            if (files.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    console.log("appending files",files[i])
                    formData.append('uploads', files[i]);
                }
                console.log("Uploads", formData.get('uploads'));
            }
            // console.log("Form Data",formData)
            const response = await axios.post(
                process.env.REACT_APP_API_URL + "api/request/add",
                formData,
                {
                    headers: {
                        'auth-token': `${token}`
                    }
                }
            );
            const json = response.data;
            if (json.success) {
                toast.success(json.message)
                setRequests(prevRequests => [...prevRequests, json.request])
                props.close({ open: false, component: '' })
            } else {
                toast.error(json.error || json.message)
                setError(json.message || json.message[0].msg)
            }

        } catch (error) {
            console.log(error);
            // setError(error.response.data.message || error.response.data.message[0].msg)
            toast.error(error)
            setError(error.response.data.message)
        } finally {
            setLoading({ open: false, text: '' })
        }
    }

    // sending notiification erheree
    const todayDate = () => {
        let date = new Date();
        return date.getDate();
    };

    const handleDate = (e) => {
        let date = new Date(e.target.value);
        if (date.getDay() === 0) {
            toast.error("Sundays are not allowed please select another day.")
            return
        }
        setDisabled(false)
        setDateTime({ ...dateTime, [e.target.name]: e.target.value })
        setFormDetails({...formDetails, deadline: e.target.value})
    }

    const handleFileChange = (event) => {
        const fileList = event.target.files;

        // Convert FileList to Array and limit it to 5 files
        // const fileArray = Array.from(fileList).slice(0, 5);

        if (fileList.length > 5) {
            setError('You can only upload a maximum of 5 files.');
        } else {
            setError('');
            setFiles(fileList); // Update state with valid files
        }
    };


    const smallComponent = () => {
        if (fields.component === "links") {
            return <Links close={setFields} open={fields} disabled={setDisabled} link={link} setLink={setLink} links={links} setLinks={setLinks} />
        } else if (fields.component === "custom") {
            return <CustomReminder close={setFields} open={fields} />
        }
    }

    const today = new Date();
    const dayOfWeek = today.toLocaleString('default', { weekday: 'long' });

    // const monthNames = ["January", "February", "March", "April", "May", "June",
    //     "July", "August", "September", "October", "November", "December"
    // ];

    // const getNthWeekday = (date) => {
    //     const dayOfWeek = date.getDay(); // Sunday is 0, Monday is 1, etc.
    //     const dayOfMonth = date.getDate();

    //     // Calculate how many times this day has occurred so far in the month
    //     const nthOccurrence = Math.ceil(dayOfMonth / 7);

    //     // Array to map weekday numbers to names
    //     const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    //     return `${nthOccurrence} ${weekdays[dayOfWeek]}`; // e.g., "2nd Monday"
    // };


    useEffect(() => {
        if (drop[2] && searchAgencyRef.current) {
            searchAgencyRef.current.focus();
        } else if (drop[1] && searchDropRef.current) {
            searchDropRef.current.focus();
        }
    }, [drop[2], drop[1]]);


    return (
        <>
            <div className={`${styles.smallDrop} ${fields.open ? styles.active : ''} `}></div>
            <div className={`${styles.small_modal} ${fields.open ? styles.active : ''}`}>
                {smallComponent()}
            </div>
            <div className={styles.head}>
                <h3>Add Support Request</h3>
                <i className={`bx bx-x ${styles.close}`} onClick={() => props.close({ open: false, component: '' })}></i>
            </div>
            <form action="" className='h-100' onSubmit={handleSubmit}>
                <div className={styles.form_container}>
                    <div className="inputField" style={{ border: "1px solid #ddd" }}>
                        <input type="text" name='title' placeholder='Enter a Title*' onChange={handleChange} required />
                    </div>
                    <div className="row">
                    <div className="col-md-6 col-12 pe-0">
                                <div
                                    className={`dropdown search-drop ${assigned.length > 0 ? 'drop3' : ''} ${drop[3] ? 'active' : ''}`}
                                    style={{ zIndex: '9999' }}
                                >
                                    <div className="select" onClick={() => handleDrop(3)}>
                                        <div className="d-flex align-items-center overflow-hidden">
                                            {selectedTags && selectedTags.length > 0 ? (
                                                selectedTags.map((item, index) => (
                                                    <span
                                                        style={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            marginRight: '8px',
                                                            backgroundColor: '#f0f0f0',
                                                            padding: '4px 8px',
                                                            borderRadius: '4px',
                                                        }}
                                                        key={index}
                                                    >
                                                        {item.name}
                                                    </span>
                                                ))
                                            ) : (
                                                <span style={{ color: '#888' }}>Select Tags</span>
                                            )}
                                        </div>
                                        <i className="fa-solid fa-angle-up"></i>
                                    </div>
                                    <ul>
                                        <div className="drop-input">
                                            <IoSearch />
                                            <input
                                                type="text"
                                                name="tags"
                                                placeholder="Search Tags..."
                                                ref={searchTagRef}
                                                value={tagQuery}
                                                onChange={handleTagSearch}
                                            />
                                        </div>
                                        <div className="list">
                                            {filteredTags && filteredTags.length > 0 ? (
                                                filteredTags.map((item, index) => (
                                                    <li key={index}>
                                                        <label
                                                            htmlFor={`tag-${index}`}
                                                            className="d-flex align-items-center"
                                                            style={{ gap: '10px', cursor: 'pointer'}}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                id={`tag-${index}`}
                                                                checked={selectedTags.some((assignedItem) => assignedItem.name === item.name)}
                                                                onChange={() => {
                                                                    if (selectedTags.some((assignedItem) => assignedItem.name === item.name)) {
                                                                        selectedDrop(item.id, item.name, 'remove');
                                                                    } else {
                                                                        selectedDrop(item.id, item.name, 'add');
                                                                    }
                                                                }}
                                                            />
                                                            <span>{item.name}</span>
                                                        </label>
                                                    </li>
                                                ))
                                            ) : (
                                                <div style={{ padding: '8px', color: '#888' }} className='d-flex align-items-center justify-content-center h-100 w-100'>No employees found</div>
                                            )}
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        <div className="row pe-0">
                            <label htmlFor="" className='mb-1 label fw-semibold'>Select Agency</label>
                            <div className="col-md-6 col-12 pe-0">
                                <div
                                    className={`w-100 dropdown search-drop ${drop[2] ? 'active' : ''}`}
                                >
                                    <div className="select" onClick={() => { handleDrop(2); searchAgencyRef.current.focus() }}>
                                        <div className="d-flex align-items-center">
                                            <span>{agency.name ? agency.name : 'Select Agency'}</span>
                                        </div>
                                        <i className="fa-solid fa-angle-up"></i>
                                    </div>
                                    <ul>
                                        <div className="drop-input">
                                            <IoSearch />
                                            <input
                                                type="text"
                                                name="agency"
                                                placeholder="Search Agencies..."
                                                ref={searchAgencyRef}
                                                value={agencyQuery}
                                                onChange={handleAgencySearch}
                                            />
                                        </div>
                                        <div className="list">
                                            {filteredAgencies && filteredAgencies.length > 0 ? (
                                                filteredAgencies.map((item, index) => (
                                                    <li
                                                        key={index}
                                                        onClick={() => {
                                                            setAgency(item);
                                                            formDetails.agencyId = item.id
                                                        }}
                                                    >
                                                        {item.name}
                                                    </li>
                                                ))
                                            ) : (
                                                <div style={{ padding: '8px', color: '#888' }} className='d-flex align-items-center justify-content-center h-100 w-100'>No Agency found</div>   
                                            )}
                                        </div>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-6 col-12 pe-0">
                                <div
                                    className={`dropdown search-drop ${assigned.length > 0 ? 'drop2' : ''} ${drop[1] ? 'active' : ''}`}
                                    style={{ zIndex: '999' }}
                                >
                                    <div className="select" onClick={() => handleDrop(1)}>
                                        <div className="d-flex align-items-center overflow-hidden">
                                            {assigned && assigned.length > 0 ? (
                                                assigned.map((item, index) => (
                                                    <span
                                                        style={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            marginRight: '8px',
                                                            backgroundColor: '#f0f0f0',
                                                            padding: '4px 8px',
                                                            borderRadius: '4px',
                                                        }}
                                                        key={index}
                                                    >
                                                        {item.username}
                                                    </span>
                                                ))
                                            ) : (
                                                <span style={{ color: '#888' }}>Select Your HOD (2 max)</span>
                                            )}
                                        </div>
                                        <i className="fa-solid fa-angle-up"></i>
                                    </div>
                                    <ul>
                                        <div className="drop-input">
                                            <IoSearch />
                                            <input
                                                type="text"
                                                name="employees"
                                                placeholder="Search employees..."
                                                ref={searchDropRef}
                                                value={searchQuery}
                                                onChange={handleSearch}
                                            />
                                        </div>
                                        <div className="list">
                                            {filteredEmployees && filteredEmployees.length > 0 ? (
                                                filteredEmployees.map((item, index) => (
                                                    <li key={index}>
                                                        <label
                                                            htmlFor={`employee-${index}`}
                                                            className="d-flex align-items-center"
                                                            style={{ gap: '10px', cursor: 'pointer' }}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                id={`employee-${index}`}
                                                                checked={assigned.some((assignedItem) => assignedItem.username === item.username)}
                                                                onChange={() => {
                                                                    if (assigned.some((assignedItem) => assignedItem.username === item.username)) {
                                                                        assignedDrop(item.id, item.username, 'remove');
                                                                    } else {
                                                                        if(assigned.length <= 1){
                                                                            assignedDrop(item.id, item.username, 'add');
                                                                        }else{
                                                                            toast.warning("You can Select Upto 2 HODs")
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                            <span>{item.username}</span>
                                                        </label>
                                                    </li>
                                                ))
                                            ) : (
                                                <div style={{ padding: '8px', color: '#888' }} className='d-flex align-items-center justify-content-center h-100 w-100'>No employees found</div>
                                            )}
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="inputField" style={{ border: "1px solid #ddd", borderRadius: "12px" }}>
                        <textarea name="description" onChange={handleChange} id="" placeholder='Enter a Description*' rows={5} required></textarea>
                    </div>
                    <div className="row">
                        <label htmlFor="" className='mb-1 label fw-semibold'>Due Date</label>
                        <div className="col-md-6 col-12">
                            <div className="inputField" style={{ border: "1px solid #ddd" }}>
                                <input type="date" placeholder='Select Date' name='date' max={todayDate} value={dateTime.date} onChange={handleDate} required />
                            </div>
                        </div>
                    </div>

                    <div className="inputField priority" style={{ gap: "6px" }}>
                        <span className={styles.tag}>
                            <IoFlag />
                            <p>Priority</p>
                        </span>
                        <span onClick={() => { setPriority('High') }} className={`${styles.tag} ${priority == "High" ? styles.active : ""}`}>
                            <IoCheckmarkSharp />
                            <p>High</p>
                        </span>
                        <span onClick={() => { setPriority('Medium') }} className={`${styles.tag} ${priority == "Medium" ? styles.active : ""}`}>
                            <IoCheckmarkSharp />
                            <p>Medium</p>
                        </span>
                        <span onClick={() => { setPriority('Low') }} className={`${styles.tag} ${priority == "Low" ? styles.active : ""}`}>
                            <IoCheckmarkSharp />
                            <p>Low</p>
                        </span>
                    </div>
                    {/* <div className={styles.repeat}>
                        <div className="checkbox-wrapper-4">
                            <input
                                type="checkbox"
                                checked={repeatChecked}
                                className="inp-cbx"
                                onChange={() => setRepeatChecked(!repeatChecked)}  // Toggle checkbox state
                                id="repeat-checkbox"  // Unique id for input
                            />
                            <label htmlFor="repeat-checkbox" className="cbx">
                                <span><svg></svg></span>
                                <span className='text'>Repeat</span>
                            </label>
                        </div>

                        // {/* Conditionally render the dropdown based on the checkbox state */}
                        {/* {repeatChecked &&
                            <div className={`w-100 dropdown ${drop[0] ? 'active' : ''}`}
                                onClick={() => handleDrop(0)}>
                                <div className="select">
                                    <div className="d-flex align-items-center">
                                        <span>{repeat ? repeat : "Does Not Repeat"}</span>
                                    </div>
                                    <i className="fa-solid fa-angle-up"></i></div>
                                <ul>
                                    <li onClick={() => { setRepeat("does_not_repeat") }}>Does not repeat</li>
                                    <li onClick={() => { setRepeat("daily") }}>Daily</li>
                                    <li onClick={() => { setRepeat("weekly") }}>Weekly on {dayOfWeek}</li>
                                    <li onClick={() => { setRepeat("monthly") }}>Monthly on the {getNthWeekday(new Date())}</li>
                                    <li onClick={() => { setRepeat("weekday") }}>Every weekday (Monday to Friday)</li>
                                    <li onClick={() => { setRepeat("custom"); setFields({ component: 'custom', open: true }) }}>Custom Recurrence</li>
                                </ul>
                            </div>
                        }
                    </div>  */}

                    {error ? <p style={{ color: "red" }}>{error}</p> : null}
                    <p className={styles.para}>You can upload up to 5 files</p>
                    <div className="d-flex align-items-center flex-wrap" style={{ gap: "15px" }}>
                        <div className={styles.icon} data-attr="Add Links" onClick={() => { setFields({ component: "links", open: true }) }}>
                            {links.length > 0 && <span>{links.length}</span>}
                            <FaLink />
                        </div>
                        <label htmlFor='upload' className={styles.icon} data-attr="Upload Files">
                            <input type="file" style={{ display: "none" }} onChange={handleFileChange} multiple id='upload' />
                            <AiOutlineFolderOpen />
                        </label>
                        {files.length > 0 ?
                            <div className={styles.files}>
                                {Array.from(files).map((item, index) => {
                                    return <span key={index} className={styles.file}>{item.name}{files.length > index ? ',' : null}</span>
                                })}
                            </div> : null}
                        {!isRecording ? (
                            <div className={styles.icon} data-attr="Start Recording" onClick={() => { startRecording(); setDisabled(false) }}>
                                <IoIosMic />
                            </div>
                        ) : (
                            <div className={styles.icon} data-attr="Stop Recording" onClick={stopRecording}>
                                <FaRegCircleStop />
                            </div>
                        )}
                        {audioBlob && (
                            <div>
                                <audio controls src={URL.createObjectURL(audioBlob)} />
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.foot}>
                    <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                        <button type='button' className="button2 cancel" onClick={() => props.close({ open: false, component: '' })}>Cancel</button>
                        <button type='submit' className={`button2 ${disabled ? 'disabled' : ''}`} disabled={disabled}>Add</button>
                    </div>
                </div>
            </form>

        </>
    )
}

export default AddRequest;
